import { render, staticRenderFns } from "./PermissionList.vue?vue&type=template&id=50c5269e&scoped=true"
import script from "./PermissionList.vue?vue&type=script&lang=js"
export * from "./PermissionList.vue?vue&type=script&lang=js"
import style0 from "./PermissionList.vue?vue&type=style&index=0&id=50c5269e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c5269e",
  null
  
)

export default component.exports